module.exports = __webpack_public_path__ + "static/media/20n.f0bd7030.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/20n.svg
// module id = 167
// module chunks = 0